import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';

// export const fetchDataFG = createAsyncThunk(
//     'DesignMasterData/fetchDataFG',
//     async ({ cmpdetail, UserDetail, page, rowsPerPage, searchQuery }, { rejectWithValue }) => {

//         try {
//             // const result = await GET(`/products/${cmpdetail?.key}?supplier_name=${encodeURIComponent(UserDetail?.result?.user?.company_name)}&limit=100&page=1`);
//             const result = await GET(`/products/${cmpdetail?.key}?supplier_name=${encodeURIComponent(UserDetail?.result?.user?.company_name)}?page=${page}&limit=${rowsPerPage}&product_name=${encodeURIComponent(searchQuery || "")}`,);
//             return result;
//         } catch (error) {
//             return rejectWithValue(error?.response?.data?.message || error?.message)
//         }
//     }
// );
export const fetchDataFG = createAsyncThunk(
    "DesignMasterData/fetchDataFG",
    async ({ cmpdetail, UserDetail, page, rowsPerPage, searchQuery }, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams({
                supplier_name: UserDetail?.result?.user?.company_name || "",
                page: page, limit:
                    rowsPerPage,
            });

            // Add product_name only when searchQuery is present
            if (searchQuery?.trim()) {
                params.append("product_name", searchQuery.trim());
            }

            const result = await GET(`/products/${cmpdetail?.key}?${params.toString()} `);
            return result;
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || error?.message
            );
        }
    }
);

const DesignMasterDataSlice = createSlice({
    name: 'DesignMasterData',
    initialState: {
        result: {},
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDataFG.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDataFG.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.result = action.payload;
            })
            .addCase(fetchDataFG.rejected, (state, action) => {
                state.status = 'failed';
                state.result = {};
                state.error = action.payload;
            });
    },
});

export default DesignMasterDataSlice.reducer;